import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import type { GetClaimHistoryDetailResponseDto } from "../../dtos/get-claim-history-detail-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UseGetClaimHistoryDetailQueryParams = {
  queryParams: { claimId: string };
  options?: Omit<UseQueryOptions<GetClaimHistoryDetailResponseDto>, "queryKey">;
};

export const useGetClaimHistoryDetailQuery = ({
  queryParams,
  options
}: UseGetClaimHistoryDetailQueryParams) => {
  return useQuery({
    queryKey: OrderQueryKeys.getClaimHistoryDetail(queryParams.claimId)
      .queryKey,
    queryFn: async () =>
      await OrderService.getClaimHistoryDetail({ payload: queryParams }),
    ...options
  });
};
